(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 1024px)');
  var FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CLOSE_DELAY = 260;
  var OPEN_DELAY = 80;
  var PANEL_HIDE_DELAY = 250;
  var PANEL_FOCUS_DELAY = 260;

  function normalizePath(value) {
    try {
      var path = new URL(value, window.location.origin).pathname;
      return path.length > 1 ? path.replace(/\/$/, '') : path;
    } catch (error) {
      return value || '/';
    }
  }

  function directChild(element, selector) {
    return Array.prototype.find.call(element.children, function (child) {
      return child.matches && child.matches(selector);
    }) || null;
  }

  function isVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function focusables(panel) {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      isVisible
    );
  }

  function readableLabel(element, fallback) {
    var value = element.getAttribute('aria-label') || fallback || '';
    if (!value || /translation missing/i.test(value)) return fallback || '';
    return value.trim();
  }

  function addActionLabels(header) {
    var actions = [];
    header.querySelectorAll('a[href*="wishlist"], .ssw-link-fave-menu').forEach(function (link) {
      link.remove();
    });
    header.querySelectorAll('a[href*="/account"]').forEach(function (link) {
      var accountLabel = document.body.classList.contains('customer-logged-in') ? 'Account' : 'Log in';
      link.setAttribute('aria-label', accountLabel);
      actions.push({ element: link, label: accountLabel });
    });
    header.querySelectorAll('.sf-search-form button').forEach(function (button) {
      actions.push({ element: button, label: readableLabel(button, 'Search') });
    });
    header.querySelectorAll('a.cart-icon').forEach(function (link) {
      link.setAttribute('aria-label', readableLabel(link, 'Cart'));
      actions.push({ element: link, label: 'Cart' });
    });
    header.querySelectorAll('.sf-options-wrapper__desktop > a').forEach(function (link) {
      actions.push({ element: link, label: readableLabel(link, '') });
    });
    header.querySelectorAll('.sf-menu-logo-bar a[aria-label]').forEach(function (link) {
      actions.push({ element: link, label: readableLabel(link, '') });
    });
    actions.forEach(function (action) {
      if (!action.label) return;
      action.element.classList.add('ag-header-labeled-action');
      if (action.element.querySelector('.ag-header-action__label')) return;
      var label = document.createElement('span');
      label.className = 'ag-header-action__label';
      label.textContent = action.label;
      action.element.appendChild(label);
    });

    var account = header.querySelector('a[href*="/account"]');
    var cart = header.querySelector('a.cart-icon');
    if (account && cart && account.parentElement === cart.parentElement && account.nextElementSibling === cart) {
      var group = document.createElement('div');
      group.className = 'ag-header-account-cart';
      group.setAttribute('role', 'group');
      group.setAttribute(
        'aria-label',
        (document.body.classList.contains('customer-logged-in') ? 'Account' : 'Log in') + ' and cart'
      );
      account.parentElement.insertBefore(group, account);
      group.appendChild(account);
      group.appendChild(cart);
    }
  }

  function addDesktopSearch(header, searchIndex) {
    if (header.querySelector('.ag-header-search')) return;
    var legacySearch = header.querySelector('.sf-search-form');
    if (!legacySearch || !legacySearch.parentElement) return;

    var form = document.createElement('form');
    form.className = 'ag-header-search';
    form.action = '/search';
    form.method = 'get';
    form.setAttribute('role', 'search');

    var label = document.createElement('label');
    var inputId = 'ag-header-search-' + searchIndex;
    label.className = 'ag-header-search__label';
    label.htmlFor = inputId;
    label.textContent = 'Search screen guards';

    var icon = document.createElement('span');
    icon.className = 'ag-header-search__icon';
    icon.setAttribute('aria-hidden', 'true');
    var sourceIcon = legacySearch.querySelector('svg');
    if (sourceIcon) icon.appendChild(sourceIcon.cloneNode(true));

    var input = document.createElement('input');
    input.id = inputId;
    input.className = 'ag-header-search__input';
    input.type = 'search';
    input.name = 'q';
    input.placeholder = 'Search by car, model or product';
    input.autocomplete = 'off';
    input.enterKeyHint = 'search';
    input.setAttribute('aria-label', 'Search by car, model or product');

    var type = document.createElement('input');
    type.type = 'hidden';
    type.name = 'type';
    type.value = 'product';

    var submit = document.createElement('button');
    submit.className = 'ag-header-search__submit';
    submit.type = 'submit';
    submit.textContent = 'Search';

    form.appendChild(label);
    form.appendChild(icon);
    form.appendChild(input);
    form.appendChild(type);
    form.appendChild(submit);
    legacySearch.parentElement.insertBefore(form, legacySearch);

    legacySearch.hidden = true;
    legacySearch.setAttribute('aria-hidden', 'true');
    legacySearch.querySelectorAll('a, button, input').forEach(function (control) {
      control.tabIndex = -1;
    });

    form.addEventListener('submit', function (event) {
      if (input.value.trim()) return;
      event.preventDefault();
      input.focus();
    });
  }

  function markCurrentLinks(nav) {
    var current = normalizePath(window.location.href);
    var exact = null;

    nav.querySelectorAll('a[href]').forEach(function (link) {
      var rawHref = link.getAttribute('href') || '';
      if (!rawHref || rawHref.indexOf('#') !== -1) {
        link.removeAttribute('aria-current');
        return;
      }
      if (normalizePath(link.href) !== current) return;
      link.setAttribute('aria-current', 'page');
      if (!exact) exact = link;
    });

    if (!exact) return;
    var item = exact.closest('.sf-menu-item');
    if (item && item.parentElement === nav) item.classList.add('is-current');
    var parent = exact.closest('.sf-menu-item-parent');
    if (parent && parent.parentElement === nav && !parent.classList.contains('is-current')) {
      parent.classList.add('is-current-ancestor');
    }
  }

  function cleanLabel(element) {
    var clone = element.cloneNode(true);
    clone.querySelectorAll('svg, .sf-menu__arrow').forEach(function (node) { node.remove(); });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function buildMoreMenu(nav, navIndex) {
    var items = Array.prototype.filter.call(nav.children, function (child) {
      return child.matches && child.matches('.sf-menu-item');
    });
    if (items.length < 8) return null;

    var sources = items.slice(6);
    sources.forEach(function (item) { item.classList.add('ag-header-compact-source'); });

    var item = document.createElement('li');
    item.className = 'sf-menu-item sf-menu-item-parent ag-header-more';
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'sf__parent-item ag-header-more__trigger';
    trigger.setAttribute('aria-expanded', 'false');
    trigger.textContent = 'More';

    var existingArrow = nav.querySelector('.sf-menu__arrow');
    if (existingArrow) {
      var arrow = existingArrow.cloneNode(true);
      arrow.setAttribute('aria-hidden', 'true');
      trigger.appendChild(arrow);
    }

    var panel = document.createElement('div');
    panel.className = 'ag-header-more__panel';
    panel.id = 'ag-header-more-' + navIndex;
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-label', 'More navigation');
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('inert', '');
    panel.hidden = true;
    trigger.setAttribute('aria-controls', panel.id);
    trigger.setAttribute('aria-haspopup', 'true');

    var list = document.createElement('ul');
    sources.forEach(function (source) {
      var sourceLink = directChild(source, 'a[href]');
      if (!sourceLink) return;
      var listItem = document.createElement('li');
      listItem.className = 'ag-header-more__item';
      var link = document.createElement('a');
      link.className = 'ag-header-more__link';
      link.href = sourceLink.href;
      link.textContent = cleanLabel(sourceLink);
      if (sourceLink.getAttribute('aria-current')) link.setAttribute('aria-current', 'page');
      listItem.appendChild(link);

      var sourcePanel = directChild(source, '.sf-menu__desktop-sub-menu');
      if (sourcePanel) {
        var children = document.createElement('ul');
        children.className = 'ag-header-more__children';
        var seen = Object.create(null);

        sourcePanel.querySelectorAll('a[href]').forEach(function (childLink) {
          var childLabel = cleanLabel(childLink);
          var childHref = childLink.href;
          var key = childHref + '|' + childLabel;
          if (!childLabel || childHref === sourceLink.href || seen[key]) return;
          seen[key] = true;

          var childItem = document.createElement('li');
          var compactLink = document.createElement('a');
          compactLink.className = 'ag-header-more__child-link';
          compactLink.href = childHref;
          compactLink.textContent = childLabel;
          if (childLink.getAttribute('aria-current')) compactLink.setAttribute('aria-current', 'page');
          childItem.appendChild(compactLink);
          children.appendChild(childItem);
        });

        if (children.children.length) listItem.appendChild(children);
      }
      list.appendChild(listItem);
    });
    panel.appendChild(list);
    item.appendChild(trigger);
    item.appendChild(panel);
    if (list.querySelector('[aria-current="page"]')) item.classList.add('is-current-ancestor');
    nav.appendChild(item);

    return { item: item, trigger: trigger, panel: panel, kind: 'more' };
  }

  function configureCarTabs(root) {
    if (!root) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;

    function select(tab, focus) {
      var controls = tab.getAttribute('aria-controls');
      tabs.forEach(function (candidate) {
        var active = candidate === tab;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-selected', active ? 'true' : 'false');
        candidate.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function (panel) {
        var active = panel.id === controls;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (focus) tab.focus();
    }

    var current = normalizePath(window.location.href);
    var currentPanel = panels.find(function (panel) {
      return Array.prototype.some.call(panel.querySelectorAll('a[href]'), function (link) {
        var isCurrent = normalizePath(link.href) === current;
        if (isCurrent) link.setAttribute('aria-current', 'page');
        return isCurrent;
      });
    });
    var currentTab = currentPanel && tabs.find(function (tab) {
      return tab.getAttribute('aria-controls') === currentPanel.id;
    });
    var selected = currentTab || tabs.find(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    }) || tabs[0];
    select(selected, false);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('focus', function () { select(tab, false); });
    });

    root.addEventListener('keydown', function (event) {
      var tab = event.target.closest && event.target.closest('[role="tab"]');
      if (!tab) return;
      var index = tabs.indexOf(tab);
      var next = null;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
      if (event.key === 'Home') next = tabs[0];
      if (event.key === 'End') next = tabs[tabs.length - 1];
      if (!next) return;
      event.preventDefault();
      event.stopPropagation();
      select(next, true);
    }, true);

    return Boolean(currentTab);
  }

  function initNav(section, header, nav, navIndex) {
    markCurrentLinks(nav);

    var descriptors = [];
    var carRoot = section.querySelector('[data-ag-dnav-root]');
    var carPanel = carRoot && carRoot.querySelector('[data-ag-dnav-panel-root]');
    var carTrigger = Array.prototype.find.call(nav.querySelectorAll(':scope > .sf-menu-item > a'), function (link) {
      return /select\s+your\s+car/i.test(link.textContent);
    });

    Array.prototype.forEach.call(nav.querySelectorAll(':scope > .sf-menu-item'), function (item, index) {
      var trigger = directChild(item, 'a.sf__parent-item, button.sf__parent-item');
      var panel = directChild(item, '.sf-menu__desktop-sub-menu');
      if (!trigger || !panel) return;
      var id = panel.id || 'ag-header-submenu-' + navIndex + '-' + index;
      panel.id = id;
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');
      panel.hidden = true;
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', id);
      descriptors.push({ item: item, trigger: trigger, panel: panel, kind: 'standard' });

      if (trigger.tagName === 'A' && trigger.href && !panel.querySelector('.ag-header-menu__overview')) {
        var overview = document.createElement('a');
        overview.className = 'ag-header-menu__overview';
        overview.href = trigger.href;
        overview.textContent = 'View all ' + trigger.textContent.trim();
        panel.appendChild(overview);
      }
    });

    if (carTrigger && carPanel && carRoot) {
      var carItem = carTrigger.closest('.sf-menu-item');
      var duplicate = descriptors.find(function (descriptor) { return descriptor.trigger === carTrigger; });
      if (duplicate) {
        duplicate.panel.classList.add('ag-header-replaced-panel');
        duplicate.panel.setAttribute('aria-hidden', 'true');
        duplicate.panel.setAttribute('inert', '');
        duplicate.panel.hidden = true;
        descriptors.splice(descriptors.indexOf(duplicate), 1);
      }
      carPanel.setAttribute('aria-hidden', 'true');
      carPanel.setAttribute('inert', '');
      carPanel.hidden = true;
      carTrigger.setAttribute('aria-haspopup', 'true');
      carTrigger.setAttribute('aria-expanded', 'false');
      carTrigger.setAttribute('aria-controls', carPanel.id || 'ag-dnav-panel');
      descriptors.unshift({
        item: carItem,
        trigger: carTrigger,
        panel: carPanel,
        root: carRoot,
        kind: 'car'
      });
      if (configureCarTabs(carRoot)) {
        nav.querySelectorAll(':scope > .sf-menu-item.is-current, :scope > .sf-menu-item.is-current-ancestor').forEach(function (item) {
          if (item === carItem) return;
          item.classList.remove('is-current', 'is-current-ancestor');
          var trigger = directChild(item, '.sf__parent-item');
          if (trigger) trigger.removeAttribute('aria-current');
        });
        carItem.classList.add('is-current-ancestor');
      }
    }

    var more = buildMoreMenu(nav, navIndex);
    if (more) descriptors.push(more);

    var openDescriptor = null;
    var openTimer = null;
    var closeTimer = null;

    function setOpen(descriptor, open, options) {
      options = options || {};
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      window.clearTimeout(descriptor.hideTimer);
      window.clearTimeout(descriptor.focusTimer);

      if (open && openDescriptor && openDescriptor !== descriptor) {
        setOpen(openDescriptor, false, { immediate: true });
      }

      if (open) {
        var wasHidden = descriptor.panel.hidden;
        descriptor.panel.hidden = false;
        descriptor.panel.removeAttribute('inert');
        descriptor.panel.setAttribute('aria-hidden', 'false');
        descriptor.openMode = options.mode || descriptor.openMode || 'programmatic';
        section.classList.add('sf-mega-active');
        if (wasHidden) descriptor.panel.getBoundingClientRect();
      }

      descriptor.item.classList.toggle('ag-header-menu-open', open);
      descriptor.item.classList.remove('ag-touch-open');
      descriptor.trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (descriptor.kind === 'car') {
        descriptor.root.classList.toggle('ag-dnav-root-open', open);
      }

      if (!open) {
        descriptor.openMode = null;
        section.classList.remove('sf-mega-active');
        descriptor.item.classList.remove('sf-menu-item--active', 'show-menu');
        descriptor.panel.setAttribute('aria-hidden', 'true');
        descriptor.panel.setAttribute('inert', '');
        var finishHide = function () {
          if (descriptor.trigger.getAttribute('aria-expanded') === 'true') return;
          descriptor.panel.hidden = true;
          descriptor.panel.setAttribute('aria-hidden', 'true');
          descriptor.hideTimer = null;
        };
        if (options.immediate || REDUCED_MOTION.matches) finishHide();
        else descriptor.hideTimer = window.setTimeout(finishHide, PANEL_HIDE_DELAY);
      }

      openDescriptor = open ? descriptor : (openDescriptor === descriptor ? null : openDescriptor);
      if (open && options.focusFirst) {
        descriptor.focusTimer = window.setTimeout(function () {
          if (descriptor.trigger.getAttribute('aria-expanded') !== 'true') return;
          var first = descriptor.kind === 'car'
            ? descriptor.panel.querySelector('[role="tab"][aria-selected="true"]')
            : focusables(descriptor.panel)[0];
          if (first) first.focus({ preventScroll: true });
          descriptor.focusTimer = null;
        }, REDUCED_MOTION.matches ? 0 : PANEL_FOCUS_DELAY);
      }
      if (!open && options.returnFocus) descriptor.trigger.focus();
    }

    function closeOpen(returnFocus) {
      if (openDescriptor) setOpen(openDescriptor, false, { returnFocus: returnFocus });
    }

    descriptors.forEach(function (descriptor) {
      descriptor.trigger.addEventListener('click', function (event) {
        if (!DESKTOP.matches) return;
        event.preventDefault();
        var wasPinned = descriptor.trigger.getAttribute('aria-expanded') === 'true' && descriptor.openMode === 'click';
        setOpen(descriptor, !wasPinned, { focusFirst: !wasPinned, mode: 'click' });
      });

      descriptor.trigger.addEventListener('keydown', function (event) {
        if (!DESKTOP.matches) return;
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown') {
          event.preventDefault();
          setOpen(descriptor, true, { focusFirst: true, mode: 'keyboard' });
        }
      });

      descriptor.item.addEventListener('mouseenter', function () {
        if (!DESKTOP.matches || !FINE_POINTER.matches) return;
        window.clearTimeout(closeTimer);
        if (descriptor.openMode && descriptor.openMode !== 'hover') return;
        openTimer = window.setTimeout(function () {
          setOpen(descriptor, true, { mode: 'hover' });
        }, OPEN_DELAY);
      });

      descriptor.item.addEventListener('mouseleave', function () {
        if (!DESKTOP.matches || !FINE_POINTER.matches) return;
        window.clearTimeout(openTimer);
        if (descriptor.openMode && descriptor.openMode !== 'hover') return;
        closeTimer = window.setTimeout(function () { setOpen(descriptor, false); }, CLOSE_DELAY);
      });

      if (descriptor.kind === 'car') {
        descriptor.panel.addEventListener('mouseenter', function () { window.clearTimeout(closeTimer); });
        descriptor.panel.addEventListener('mouseleave', function () {
          if (descriptor.openMode && descriptor.openMode !== 'hover') return;
          closeTimer = window.setTimeout(function () { setOpen(descriptor, false); }, CLOSE_DELAY);
        });
      }
    });

    nav.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      var topTrigger = event.target.closest && event.target.closest('.sf-nav > .sf-menu-item > .sf__parent-item');
      if (!topTrigger) return;
      var triggers = Array.prototype.filter.call(
        nav.querySelectorAll(':scope > .sf-menu-item > .sf__parent-item'),
        isVisible
      );
      var index = triggers.indexOf(topTrigger);
      if (index < 0) return;
      event.preventDefault();
      closeOpen(false);
      var delta = event.key === 'ArrowRight' ? 1 : -1;
      triggers[(index + delta + triggers.length) % triggers.length].focus();
    });

    section.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!openDescriptor) return;
        var active = document.activeElement;
        if (!openDescriptor.item.contains(active) && !openDescriptor.panel.contains(active)) {
          setOpen(openDescriptor, false);
        }
      }, 0);
    });

    document.addEventListener('pointerdown', function (event) {
      if (!openDescriptor) return;
      if (openDescriptor.item.contains(event.target) || openDescriptor.panel.contains(event.target)) return;
      closeOpen(false);
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !openDescriptor) return;
      event.preventDefault();
      closeOpen(true);
    });

    window.addEventListener('scroll', function () { closeOpen(false); }, { passive: true });
    window.addEventListener('resize', function () { if (!DESKTOP.matches) closeOpen(false); });
  }

  function initHeader(section) {
    if (section.dataset.agW2HeaderReady === 'true') return;
    var header = section.querySelector('header.sf-header__desktop');
    var navs = header && header.querySelectorAll('.sf-nav');
    if (!header || !navs.length) return;
    section.dataset.agW2HeaderReady = 'true';

    addActionLabels(header);
    addDesktopSearch(header, Array.prototype.indexOf.call(document.querySelectorAll('.sf-header'), section));
    navs.forEach(function (nav, navIndex) { initNav(section, header, nav, navIndex); });
    document.documentElement.classList.add('ag-header-ready');
  }

  function init() {
    document.querySelectorAll('.sf-header').forEach(initHeader);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
